import { comments } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading mb-3">
            吃瓜热评
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[600px] mx-auto">
            百万吃瓜群众的真实声音
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 rounded-xl p-5 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-primary-700">{comment.avatar}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-semibold text-foreground-900 text-sm">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-foreground-700 text-sm leading-relaxed mb-3">{comment.content}</p>
              <div className="flex items-center gap-2 text-xs text-foreground-400">
                <i className="ri-thumb-up-line w-3.5 h-3.5 flex items-center justify-center"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}